const browserEnv =
  typeof window !== 'undefined' && window.__ENV__
    ? window.__ENV__
    : {}

const readEnv = (browserValue, processValue) =>
  browserValue !== undefined ? browserValue : processValue || ''

export const env = {
  REACT_APP_API: readEnv(
    browserEnv.REACT_APP_API,
    process.env.REACT_APP_API
  ),
  REACT_APP_LOCAL: readEnv(
    browserEnv.REACT_APP_LOCAL,
    process.env.REACT_APP_LOCAL
  ),
  REACT_APP_KEY_TOKEN: readEnv(
    browserEnv.REACT_APP_KEY_TOKEN,
    process.env.REACT_APP_KEY_TOKEN
  ),
}
